
import {decode }from 'html-entities'
import { mapGetters } from 'vuex'
import parseShortcodes from '~/modules/shortcodes'
import promoData from '@/data/promo.json'
import optionsData from '@/data/options.json'

// <html lang> per page, derived from the WP page's own URI prefix.
// Add further entries here if more non-English landing pages are added later.
const LOCALE_URI_PREFIXES = { '/es/': 'es' }
function localeForUri(uri) {
  if (typeof uri !== 'string') return 'en'
  const prefix = Object.keys(LOCALE_URI_PREFIXES).find((p) => uri.startsWith(p))
  return prefix ? LOCALE_URI_PREFIXES[prefix] : 'en'
}

export default {
  data() {
    return {
      promoData,
      showKeyPoints: false,
      // activeCampaign: null,
      mounted: false,
    }
  },
  /* eslint-disable */
  async asyncData({ $page, store, route, error }) {
    try {
      const page = $page ? $page : await store.dispatch('pages/getPage', route.fullPath)
      return { page }
    } catch (err) {
      error({ statusCode: 404, message: 'Page could not be found' })
    }
  },
  //<link rel="alternate" href="https://www.tefl.org/courses/classroom/" hreflang="x-default" />
  head() {
    const title = this.page.seo.fullHead.child
      .map((el) => (el.tag === "title" ? el.child[0].text : null))
      .filter((el) => el)[0];
    const metas = this.page.seo.fullHead.child.filter((tag) => tag.node === "element");
    const metasArray = metas.filter((m) => m.tag === "meta").map((m) => m.attr);
    const linkArray = metas.filter((m) => m.tag === "link").map((m) => m.attr);
    const scriptArray = metas.filter((m) => m.tag === "script");
    const hreflangArray = this.page.hreflang;
    let meta = [];
    let link = [];
    let script = [];
    // let hreflang = []

    if(process.env.ROBOTS === 'LIVE'){
      metasArray.push({name:'robots', content: `${this.page.seo.metaRobotsNoindex}, ${this.page.seo.metaRobotsNofollow}`})
    } else {
      metasArray.push({name:'robots', content:'noindex, nofollow'})
    }
    for (let i = 0; i < metasArray.length; i++) {
      let obj = {};
      if (metasArray[i].name)
        obj.name = metasArray[i].name;
      if (metasArray[i].property)
        obj.property = metasArray[i].property;
      obj.content =
        typeof metasArray[i].content === "string"
          ? metasArray[i].content.replace(/(?<!\w-)\b\w+\.tefl\.org\b/g, "www.tefl.org")
          : metasArray[i].content.join(" ");
      meta.push(obj);
    }
    for (let i = 0; i < linkArray.length; i++) {
      let obj = {};
      obj.rel = linkArray[i].rel;
      obj.href = linkArray[i].href.replace(/(?<!\w-)\b\w+\.tefl\.org\b/g, "www.tefl.org");
      link.push(obj);
    }
    for (let i = 0; i < scriptArray.length; i++) {
      let obj = {};
      obj.class = scriptArray[i].attr.class;
      obj.type = scriptArray[i].attr.type;
      obj.innerHTML = `${scriptArray[i].child[0].text.replace(/(?<!\w-)\b\w+\.tefl\.org\b/g, "www.tefl.org")}`;
      script.push(obj);
    }
    if(hreflangArray){
      for (let i = 0; i < hreflangArray.length; i++) {
        let obj = {};
        obj.rel = hreflangArray[i].rel;
        obj.hreflang = hreflangArray[i].hreflang;
        obj.href = hreflangArray[i].href;
        link.push(obj);
      }
    }
    return {
      htmlAttrs: { lang: localeForUri(this.page.uri) },
      title: decode(title),
      meta: meta,
      link: link,
      script: script,
      __dangerouslyDisableSanitizers: ["script"],
    };
  },
  computed: {
    hdstyle() {
      const style = Math.floor(Math.random() * 4) + 1;
      return style;
    },
    activeCampaign() {
      if (!this.$campaign || !this.$campaign.isActive) return null
      const offer = this.$campaign.offerForRegion(this.region)  // normalises internally now
      if (offer === 'free-product') return { slug: 'free-product' }
      if (offer && offer.offerText) return this.$campaign
      return null
    },
    hasActiveCampaignForPage() {
      if (!this.$route.path.includes('special-offers')) return false

      // Free product counts as an active campaign
      if (optionsData.free_offer === '1' && optionsData.freeproduct_id) return true

      const campaign = promoData.activeCampaign
      if (!campaign || !campaign.slug || !campaign.startDate || !campaign.endDate) return false
      const today = new Date().toISOString().slice(0, 10)
      if (today < campaign.startDate || today > campaign.endDate) return false
      if (!Array.isArray(campaign.offers)) return false
      return campaign.offers.some(o => o.offer && o.offer.offerText)
    },
    lastWord() {
      let words = this.page.title
      let n = words.trim().split(" ");
      let second = n.pop()
      let first = n.join(" ");
      return '<small>'+first+'</small><br>'+second
    },
    ...mapGetters({
      detectedRegion: 'geolocation/region',
      userRegion: 'user/region',
    }),
    region() {
      return this.userRegion === 'default' ? this.detectedRegion : this.userRegion
    },
    content() {
      function renderParams(token) {
        if (token) {
          if (Object.keys(token)) {
            return (" " +
              Object.entries(token)
                .map((pair) => {
                  let value = pair[1];
                  let key = ":" + pair[0];
                  if (typeof pair[1] === "string") {
                    value = `"${value}"`;
                    key = pair[0];
                  }
                  return `${key}=${value}`;
                })
                .join(" "));
          }
        }
        return "";
      }
      function renderComponent(c) {

        if (c.shortcode=='graduates'){
          c.attributes={}
c.attributes.children=`${encodeURIComponent(JSON.stringify(c.children))}`

        }
        // console.log('----',c.shortcode)
        // console.log('renderComponent c', c)
        const content = c.content ? c.content : "";
        // console.log('renderComponent content', content)
        const params = c.attributes ? renderParams(c.attributes) : "";
        // console.log('renderComponent params', params)
        const children = c.children
          ? c.children.map(renderComponent).join("")
          : "";
        //  const content = c.content?c.content:''
        // console.log('renderComponent children', children)
        console.log('----',c.shortcode)

        return `<component :is=${c.shortcode} ${params}>${content}${children}</component>`;
      }
      const re = new RegExp(`\\[(\\]?)([a-z_-]+)(?![\\w-])([^\\]]*(?:\/(?!\\])[^\]\/]*)*?)(?:(\/)\\]|\\](?:((?:(?!^\[])[^\[])*(?:\\[(?!\\/\\2\\])(?:(?!a-z)[^\[])*)*)\\[\\/\\2\\])?)`, "gm");

      if (this.page.content) {
        // Strip stray non-breaking/regular spaces that WordPress's widow-prevention
        // filter inserts right before closing tags, causing visible trailing gaps
        this.page.content = this.page.content.replace(/[\s\u00A0]+(<\/a>|<\/p>)/g, '$1');
        console.log('RAW CONTENT: ', this.page.content)
        this.page.content = this.page.content.replace(/<i class="fas fa-check">(\n*)?<\/i>/gmi, '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 mr-2 text-green-600"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" /></svg>');
        this.page.content = this.page.content.replace(/<i class="fas fa-times">(\n*)?<\/i>/gmi, '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-2 text-red-600"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>');
      }

      if ('--',this.page.content) {
      //  console.log(this.page.uri)
        this.page.content = this.page.content.replace(/<i\s[^>]*?class="(fa\sfa-([a-z-]*)[^>]*?)">(\n*)<\/i>/gmi, `<fa class="$1" icon="$2"  />`);
        this.page.content = this.page.content.replace(/<!--(.*?)-->/gm, "");
        //fix icons
        //let route=this.page
        return this.page.content.replace(re, ($0) => {

          $0 = $0.replace(/accordion-item/gm, "accordion_item");

          $0 = $0.replace(/display-posts/gm, "display_posts");
          $0 = $0.replace(/user-submitted-posts/gm, "user_submitted_posts");
          $0 = $0.replace(/(\r\n|\n|\r)/gm, "");
          let res = parseShortcodes($0);
          console.log('SHORTCODE INPUT:', $0)
          console.log('SHORTCODE OUTPUT:', res[0] ? renderComponent(res[0]) : "EMPTY")
/*           if(res[0]?.shortcode){
          console.log(route.uri,res[0].shortcode)
          } */
          return res[0] ? renderComponent(res[0]) : "";
        });
      }
    },
    replaceShortCodes() {
      if (this.content)
        return {
          template: `<div>${this.content}</div>`,
          data() {
            return {
              course_info: "CourseInfoOld",
              course_info_new: "CourseInfo",
              course_info_virtual: "CourseInfoVirtual",
              reviews: "UIReviewsAlt",
              set_taster_session: "SetTasterSession",
              tefl_resources: "TeflResources",
              tefl_newsletter: "TeflNewsletter",
              user_browser_info: "UserBrowserInfo",
              online_course_info: "OnlineCourseInfo",
              go_overseas: "GoOverseas",
              podcast_player: "PodcastPlayer",
              go_abroad: "GoAbroad",
              display_posts: "DisplayPosts",
              tquk: "TQUK",
              hideusa: "HideUSA",
              showusa: "ShowUSA",
              tefl_callback: "TeflCallback",
              tefl_box: "TeflBox",
              tefl_virtual_video: "TeflVirtualVideo",
              tefl_internship_download: "InternshipDownload",
              img_mask: "ImageMask",
              tefl_button: "TeflButton",
              embed: "EmbedVideo",
              transcript: "Transcript",
              ///////// CART  /////////////////////////
              transaction_details: "CartTransactionDetails",
              book_online_course_button: "CartBookOnlineCourseButton",
              book_course_button: "CartBookCourseButton",
              tefl_resources: "CartDownloads",
              show_price: "CartPrice",
              ////////////////////////////////////////////
              ///////////// TABLES    //////////////////////
              tefl_extensions_table: "TablesTeflExtensionsTable",
              tefl_table_countries: "TablesTeflTableCountries",
              tefl_table_online: "TablesTeflTableOnline",
              tefl_comparison_table: "TablesComparisonTable",
              cost_of_living: "TablesCostOfLivingTable",
              //////////////////////////////////////////////
              tefl_pricing_table: "CartTeflPricingTable",
              accordion: "Accordion",
              accordion_item: "AccordionItem",
              ////////////   CARDS    //////////////////////
              bundle_steps: "CardsBundleSteps",
              article_card: "CardsArticleCard",
              course_card_related_new: "CardsCourseCardRelatedNew",
              course_card_related: "CardsCourseCardRelated",
              course_card: "CardsCourseCountryCard",
              // new_custom_card: "CardsCourseCard",
              tefl_priority: "CardsTeflPriority",
              special_offers: "CardsSpecialOffers",
              new_custom_card: "CardsNewCustomCard",
              podcast_cards: "CardsPodcastCards",
              podcast_card: "CardsPodcastCard",
              course_cards: "CardsCourseCards",
              new_card: "CardsNewCard",
              course_cards_online: "CardsCourseCardsOnline",
              course_cards_bundles: "CardsCourseCardsBundles",
              course_cards_combined: "CardsCourseCardsCombined",
              course_cards_diploma: "CardsCourseCardsDiploma",
              course_cards_advanced: "CardsCourseCardsAdvancedGrid",
              course_cards_virtual: "CardsCourseCardsVirtual",
              course_cards_classroom: "CardsCourseCardsClassroom",
              course_cards_partnerships: "CardsCourseCardsPartnerships",
              tefl_location_map: "CardsLocationMap",
              tefl_locations_england: "CardsLocationsEngland",
              tefl_locations_wales: "CardsLocationsWales",
              tefl_locations_scotland: "CardsLocationsScotland",
              tefl_locations_ireland: "CardsLocationsIreland",
              tefl_locations_nireland: "CardsLocationsNIreland",
              interactive_map: "CardsInteractiveMap",
              course_cards_teo: "CardsCourseCardsTEOBundle",
              course_cards_tyl: "CardsCourseCardsTYLBundle",
              course_cards_tbe: "CardsCourseCardsTBEBundle",
              course_cards_ultimate: "CardsCourseCardsUltimateBundle",
              partnership_logos: "CardsPartnerships",
              accreditation_logos: "CardsAccreditation",
              student_stories_feed: "CardsStudentStories",
              student_stories_filter: "CardsStudentStoriesFiltered",
              tiktok_feed: "CardsTikTokFeed",
              webinar: "CardsWebinar",
              location_grid: "CardsLocationGrid",

              //////////////////////////////////////////////
              ///////////  JOBS    /////////////////////////
              jobs: "JobsJobSearch",
              job_feed_country: "JobsJobFeedCountry",
              job_feed: "JobsJobFeed",
              job_card: "JobsJobCard",
              job_card_country: "JobsJobCardCountry",
              job_card_recommended: "JobsJobCardRecommended",
              tefl_jobs_box: "JobsJobBox",
              tefl_jobs_box_country: "JobsJobBoxCountry",
              job_feed_summercamp: "JobsJobFeedSummercamp",
              job_feed_home: "HomepageJobsNew",
              jobs_intro: "JobsJobIntro",
              //////////////////////////////////////////////
              user_submitted_posts: "UserSubmitted",
              tefl_brochure_compact: "TeflBrochureCompact",
              /////////////   GUIDES ////////////////////
              tefl_europe_guide: "GuidesTeflEuropeGuide",
              tefl_world_guide: "GuidesTeflWorldGuide",
              tefl_online_guide: "GuidesTeflOnlineGuide",
              tefl_asia_guide: "GuidesTeflAsiaGuide",
              tefl_middleeast_guide: "GuidesTeflMiddleEastGuide",
              tefl_latin_america_guide: "GuidesTeflLatinAmericaGuide",
              tefl_salary_guide: "GuidesTeflSalaryGuide",
              //////////////////////////////////////////////
              /////////////    FORMS /////////////////////
              certificate_lookup: "FormsCertificateLookup",
              tefl_taster_signup: "FormsTeflTasterSignup",
              tefl_brochure: "FormsTeflBrochure",
              tefl_elt_signup: "FormsTeflEltSignup",
              login_form: "FormsLoginForm",
              submit_resume_form: "FormsSubmitResume",
              gravityform: "FormsGravity",
              reset_password: "FormsResetPassword",
              sharer_form: "FormsSharer",
              submit_job_form: "FormsSubmitJobForm",
              contact_us: "FormsContactUs",
              free_english_signup: "FormsFreeEnglishSignup",
              free_english_signup_es: "FormsFreeEnglishSignupEs",
              free_english_trial_class_confirm: "FormsFreeEnglishTrialClassConfirm",
              ////////////////////////////////////////////
              ///// BLOG  /////////////////
              blog_card_custom: "BlogCardCustom",
              caption: "BlogCaption",
              ////////////////////////
              layerslider: "europe",
              resumes: "europe",
              candidate_dashboard: "europe",
              metaslider: "europe",
              checkout: "europe",
              show_cart: "europe",
              course_locator: "europe",
              cart_spinner: "europe",
              membership: "membership",
              stripe_balance: "CartStripeBalance",
              job_dashboard: "europe",
              bg_block: "BgBlock",
              image_mask: "ImageMask",
              /////// FAQS ///////////////////
              faq_page: "FaqsFaqPageManager",
              faq_container: "FaqsFaqContainer",
              faq_item: "FaqsFaqItem",
              faq_navigation: "FaqsFaqNavigation",
              /////// BLOCKS ///////////////////
              block: "BlocksBlock",
              color_block: "BlocksColorBlock",
              img_bg_block: "BlocksImageBgBlock",
              box: "BlocksBox",
              boxout: "BlocksBoxout",
              boxout_yt: "BlocksBoxoutYoutube",
              btn_block: "BlocksBtnBlock",
              faqs: "BlocksFaqs",
              faq: "BlocksFaq",
              img_block: "BlocksImgBlock",
              list_box: "BlocksListBox",
              list_item: "BlocksListItem",
              tab: "BlocksTab",
              tab_menu: "BlocksTabMenu",
              tab_content: "BlocksTabContent",
              half: "BlocksHalf",
              half_last: "BlocksHalfLast",
              third: "BlocksThird",
              third_last: "BlocksThirdLast",
              infobox: "BlocksInfoBox",
              icon_grid: "BlocksIconGrid",
              cards: "BlocksCards",
              card: "BlocksCard",
              download_button: "BlocksDownloadButton",
              download_box: "BlocksDownloadBox",
              table_of_contents: "BlocksTableOfContents",
              text: "BlocksText",
              why_webinar: "BlocksWhyWebinar",
              author_block: 'BlocksAuthorBlock',
              pro_tip: 'BlocksProTip',
              block_quote: 'BlocksBlockQuote',
              get_guide: 'BlocksGetGuide',
              course_cta: 'BlocksCourseCta',
              country_cta_course: 'CTAsCourseCta',
              country_cta_newsletter: 'CTAsNewsletterCta',
              country_cta_online: 'CTAsOnlineGuideCta',
              country_cta_salary: 'CTAsSalaryGuideCta',
              /////////////////////////////////////
              /////// Sliders ////////
              tefl_slider: "SlidersSlider",
              tefl_slider_start: "SlidersSliderStart",
              tefl_slider_end: "SlidersSliderEnd",
              ///////////////////
              /////// Course Pages ////////
              whytefl: "CoursesWhy",
              whytefl_new: "CoursesWhyNew",
              tab_container: "CoursesTabsContainer",
              modules_menu: "CoursesModulesMenu",
              modules_tab: "CoursesModulesTab",
              modules_content_container: "CoursesModulesContentContainer",
              modules_content: "CoursesModulesContent",
              course_accreditation: "CoursesAccreditation",
              course_accreditation_new: "CoursesAccreditationNew",
              career: 'CoursesCareer',
              buy_now_blue: "CoursesBookNowAlt",
              buy_now_new: "CoursesBookNowNew",
              graduates: "CoursesGraduates",
              graduate_testimonial: null,
              grad_stories: "HomepageGradStories",
              course_faqs: "CoursesFAQ",
              course_reviews: "CoursesReviews",
              buy_now: "CoursesBookNow",
              modal_faqs: "CoursesModalFAQs",
              useful_posts: "CoursesUsefulPosts",
              purchase_button: "CoursesPurchaseButton",
              vocal_video: "CoursesVocalVideo",
              course_quiz: "CoursesCourseQuiz",
              course_quiz_custom: "CoursesCourseQuizCustom",
              course_quiz_modal: "CoursesCourseQuizModal",
              course_quiz_button: "CoursesCourseQuizButton",
              youtube: "CoursesYoutube",
              tiktok: "CoursesTikTok",
              tiktokalt: "CoursesTikTokAlt",
              whybox: "CoursesWhybox",
              cert_image: "CoursesCertImage",
              gift_voucher: "CoursesGiftVoucher",
              course_tabs: "CoursesTabsNew",
              study_your_way: "CoursesStudyYourWay",
              ///////////////////
              recommend: "BlocksRecommend",
              recommend_card: "BlocksRecommendCard",
              virtual_toggle: "VirtualToggle",
              bundle_toggle: "BundleToggle",
              toggle_container: "CoursesToggleContainer",
              team_member: "TeamMember",
              display_price: "DisplayPrice",
              classroom_modal: "CoursesClassroomModal",
              bundle_modal: "CoursesBundleModal",
              show_more: "ShowMore",
              form_reviews_banner: "FormReviewsBanner",
              form_reasons: "FormReasons",
              key_insights: "GuidesKeyInsights",
              slide: "SlidersSlide",
              tefl_promos: "TeflPromos",
              message_box: "MessageBox",
              video_submission: "UIVideoButton",
              overview_why: "UIOverWhy",
              overview_jobs: "UIOverJobs",
              overview_accreditation: "UIOverAccreditation",
              sticky_nav: "UIStickyNavMenu",
              sticky_nav_link: "UIStickyNavLink",
              ///////// schema /////////
              accreditation: "SchemaAccreditation",
              fact_list: "SchemaFactList",
              fact: "SchemaFact",
              organization: "SchemaOrganization",
              breadcrumb: "SchemaBreadcrumb",
              bf_slider: "HomepageHeroSliderBF",
              cm_slider: "HomepageHeroSliderCM",
              bf_cards: "CardsBFCards",
              quiz_boxed: "HomepageQuizBoxed",
              country_salary: "CountrySalary",
              podcast: "HomepagePodcast",
              job_guide_list: "JobsJobGuideList",
              grad_stories: "HomepageGradStories",
              spring_sale_hero: "UISpringSaleHero",
              summer_sale_hero: "UISummerSaleHero",
              totum: "UITotum",
              summer_bundles_hero: "UISummerBundlesHero",
              summer_virtual_hero: "UISummerVirtualHero",
              summer_finale_hero: "UISummerFinaleHero",
            };
          },
        };
    },
  },
  methods: {
    handleContentLoaded(hasContent) {
      console.log('_.vue: handleContentLoaded called with:', hasContent)
      this.showKeyPoints = hasContent
    }
  },
  mounted() {
    this.$nextTick(function () {
      if (this.page.categories.nodes.length > 0) {
        const category = this.page.categories.nodes[0].name
        this.$gtm.push({ 'content_group': category })
      }
    })

    // if (this.$campaign && this.$campaign.isActive) {
    //   const offer = this.$campaign.offerForRegion(this.region)
    //   if (offer === 'free-product') {
    //     this.activeCampaign = { slug: 'free-product' }
    //   } else if (offer && offer.offerText) {
    //     this.activeCampaign = this.$campaign
    //   }
    // }
    this.mounted = true
  },
}
